"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Labels = void 0;
var _form = require("@clayui/form");
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _label2 = _interopRequireDefault(require("@clayui/label"));
var _shared = require("@clayui/shared");
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["allowsCustomLabel", "aria-activedescendant", "ariaDescriptionId", "closeButtonAriaLabel", "disabled", "inputName", "insetAfter", "labels", "lastChangesRef", "locator", "onChange", "onFocusChange", "onLabelsChange", "placeholder", "spritemap", "suggestionList", "value"];
/**
 * SPDX-FileCopyrightText: © 2023 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var DELIMITER_KEYS = ['Enter', ','];
var KeysNavigation = [_shared.Keys.Left, _shared.Keys.Right, _shared.Keys.Up, _shared.Keys.Down];
var KeysSides = [_shared.Keys.Left, _shared.Keys.Right];
var counterUid = 0;
var Labels = exports.Labels = /*#__PURE__*/_react.default.forwardRef(function Labels(_ref, ref) {
  var allowsCustomLabel = _ref.allowsCustomLabel,
    activeDescendant = _ref['aria-activedescendant'],
    ariaDescriptionId = _ref.ariaDescriptionId,
    closeButtonAriaLabel = _ref.closeButtonAriaLabel,
    disabled = _ref.disabled,
    inputName = _ref.inputName,
    _ = _ref.insetAfter,
    labels = _ref.labels,
    lastChangesRef = _ref.lastChangesRef,
    locator = _ref.locator,
    _onChange = _ref.onChange,
    onFocusChange = _ref.onFocusChange,
    onLabelsChange = _ref.onLabelsChange,
    placeholder = _ref.placeholder,
    spritemap = _ref.spritemap,
    suggestionList = _ref.suggestionList,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var inputRef = (0, _react.useRef)(null);
  var labelsRef = (0, _react.useRef)(null);
  var lastItemRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    isLabelFocused = _useState2[0],
    setIsLabelFocused = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    lastFocusedItem = _useState4[0],
    setLastFocusedItem = _useState4[1];
  var inputElementRef = ref || inputRef;
  var labelId = (0, _shared.useId)();
  var getSourceItemByLabel = function getSourceItemByLabel(label) {
    return suggestionList.find(function (item) {
      return item[locator.label] === label;
    });
  };
  var getNewItem = function getNewItem(value) {
    var _ref2;
    counterUid++;
    return getSourceItemByLabel(value) || (_ref2 = {}, _defineProperty(_ref2, locator.label, value), _defineProperty(_ref2, locator.value, value), _defineProperty(_ref2, "key", "key_".concat(counterUid)), _ref2);
  };
  var onRemove = (0, _react.useCallback)(function (label, index) {
    if (labelsRef.current) {
      var focusableElements = Array.from(labelsRef.current.querySelectorAll('button'));
      var activeElement = document.activeElement.tagName === 'SPAN' ? document.activeElement.querySelector('button') : document.activeElement;
      var position = focusableElements.indexOf(activeElement);
      var closeElement = focusableElements[focusableElements.length - 1 > position ? position + 1 : position - 1];
      if (closeElement) {
        closeElement.focus();
        setLastFocusedItem(closeElement.getAttribute('id'));
      } else {
        var _inputElementRef$curr;
        (_inputElementRef$curr = inputElementRef.current) === null || _inputElementRef$curr === void 0 ? void 0 : _inputElementRef$curr.focus();
        setLastFocusedItem(null);
      }
    }
    lastChangesRef.current = {
      action: 'removed',
      label: label
    };
    onLabelsChange(labels.filter(function (_, itemIndex) {
      return itemIndex !== index;
    }));
  }, [labels]);
  return /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, null, /*#__PURE__*/_react.default.createElement(_form.ClayInput.Group, null, /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, {
    "aria-labelledby": otherProps['aria-labelledby'],
    className: "d-contents",
    onFocus: function onFocus(event) {
      return setLastFocusedItem(event.target.getAttribute('id'));
    },
    onKeyDown: function onKeyDown(event) {
      if (KeysNavigation.includes(event.key)) {
        // Query labels and buttons to exclude the label that are
        // focusable the navigation order depends on which orientation
        // the navigation is happen.
        // - Left and Right. Query all elements.
        // - Up and Down. Query for elements of the same type as the
        //   last focused element.
        var focusableElements = Array.from(event.currentTarget.querySelectorAll(KeysSides.includes(event.key) ? '[role=gridcell][tabindex], button' : lastFocusedItem !== null && lastFocusedItem !== void 0 && lastFocusedItem.includes('span') ? '[role=gridcell][tabindex]' : 'button'));
        var position = focusableElements.indexOf(document.activeElement);
        var key = KeysSides.includes(event.key) ? _shared.Keys.Left : _shared.Keys.Up;
        var label = focusableElements[event.key === key ? position - 1 : position + 1];
        if (label) {
          setLastFocusedItem(label.getAttribute('id'));
          label.focus();
        }
      }
      if (event.key === _shared.Keys.Home || event.key === _shared.Keys.End) {
        var isLabel = lastFocusedItem.includes('span');
        if (isLabel && event.key === _shared.Keys.Home || !isLabel && event.key === _shared.Keys.End) {
          return;
        }
        var _label = event.currentTarget.querySelector("[id=".concat(lastFocusedItem === null || lastFocusedItem === void 0 ? void 0 : lastFocusedItem.replace(isLabel ? 'span' : 'close', event.key === _shared.Keys.Home ? 'span' : 'close'), "]"));
        if (_label) {
          setLastFocusedItem(_label.getAttribute('id'));
          _label.focus();
        }
      }
    },
    prepend: true,
    ref: function ref(_ref5) {
      labelsRef.current = _ref5;
    },
    role: "grid",
    shrink: true
  }, labels.map(function (item, i) {
    var _item;
    var uid = (_item = item[locator.id]) !== null && _item !== void 0 ? _item : item[locator.value];
    var id = "".concat(labelId, "-label-").concat(uid, "-span");
    var closeId = "".concat(labelId, "-label-").concat(uid, "-close");
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: id
    }, /*#__PURE__*/_react.default.createElement(_label2.default, {
      className: isLabelFocused === id ? 'focus' : undefined,
      onKeyDown: function onKeyDown(_ref3) {
        var key = _ref3.key;
        if (key === _shared.Keys.Backspace) {
          onRemove(item[locator.label], i);
        }
      },
      role: "row",
      spritemap: spritemap,
      tabIndex: -1,
      withClose: false
    }, /*#__PURE__*/_react.default.createElement(_label2.default.ItemExpand, {
      "aria-describedby": ariaDescriptionId,
      id: id,
      onBlur: function onBlur() {
        return setIsLabelFocused(null);
      },
      onFocus: function onFocus() {
        return setIsLabelFocused(id);
      },
      role: "gridcell",
      style: {
        outline: 'none'
      },
      tabIndex: lastFocusedItem === null && i === 0 || lastFocusedItem === id ? 0 : -1
    }, item[locator.label]), /*#__PURE__*/_react.default.createElement(_label2.default.ItemAfter, {
      role: "gridcell"
    }, /*#__PURE__*/_react.default.createElement("button", {
      "aria-label": (0, _shared.sub)(closeButtonAriaLabel, [item[locator.label]]),
      className: "close",
      disabled: disabled,
      id: closeId,
      onClick: function onClick() {
        return onRemove(item[locator.label], i);
      },
      ref: function ref(_ref4) {
        if (i === labels.length - 1) {
          lastItemRef.current = _ref4;
        }
      },
      tabIndex: lastFocusedItem === closeId ? 0 : -1,
      type: "button"
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      spritemap: spritemap,
      symbol: "times-small"
    })))), inputName && /*#__PURE__*/_react.default.createElement("input", {
      name: inputName,
      type: "hidden",
      value: item[locator.value]
    }));
  })), /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, {
    prepend: true
  }, /*#__PURE__*/_react.default.createElement("input", _extends({}, otherProps, {
    "aria-activedescendant": activeDescendant,
    className: "form-control-inset",
    disabled: disabled,
    onBlur: function onBlur(event) {
      if (otherProps.onBlur) {
        otherProps.onBlur(event);
      }
      onFocusChange(false);
    },
    onChange: function onChange(event) {
      var value = event.target.value;
      event.target.value = allowsCustomLabel ? value.replace(',', '') : value;
      _onChange(event);
    },
    onFocus: function onFocus(event) {
      if (otherProps.onFocus) {
        otherProps.onFocus(event);
      }
      onFocusChange(true);
    },
    onKeyDown: function onKeyDown(event) {
      if (otherProps.onKeyDown) {
        otherProps.onKeyDown(event);
      }
      var key = event.key;
      if (key === _shared.Keys.Backspace && !value) {
        event.preventDefault();
      }
      if (key === _shared.Keys.Enter && activeDescendant) {
        return;
      }
      if (allowsCustomLabel && value.trim() && DELIMITER_KEYS.includes(key)) {
        event.preventDefault();
        lastChangesRef.current = {
          action: 'added',
          label: value
        };
        onLabelsChange([].concat(_toConsumableArray(labels), [getNewItem(value)]));

        // @ts-ignore
        _onChange({
          target: {
            value: ''
          }
        });
      } else if (!value && key === _shared.Keys.Backspace && inputElementRef.current && lastItemRef.current) {
        inputElementRef.current.blur();
        lastItemRef.current.focus();
      }
    },
    onPaste: function onPaste(event) {
      if (otherProps.onPaste) {
        otherProps.onPaste(event);
      }
      if (event.defaultPrevented) {
        return;
      }
      var pastedText = event.clipboardData.getData('Text');
      var pastedItems = pastedText.split(',').map(function (itemLabel) {
        return getNewItem(itemLabel.trim());
      }).filter(Boolean);
      if (allowsCustomLabel && pastedItems.length > 0) {
        event.preventDefault();
        onLabelsChange([].concat(_toConsumableArray(labels), _toConsumableArray(pastedItems)));
      }
    },
    placeholder: labels.length ? undefined : placeholder,
    ref: inputElementRef,
    type: "text",
    value: value
  })))));
});